module.exports = __webpack_public_path__ + "img/intro05.2fd0032.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/intro/intro05.png
// module id = 867
// module chunks = 1